/* tslint:disable */
import { Injectable, OnDestroy } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import {
  debounceTime, delay, withLatestFrom, map, switchMap, catchError, mergeMap, filter, throttleTime, flatMap, concatMap,
  takeUntil
} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import {
  ApplicationActionType, DelayedAction, GetLayers,
  Search, SearchCoordinates, SearchCoordinatesError,
  SearchCoordinatesSuccess, SetToolboxStatus,
  GridSelectLayer, GetGridSelectLayerSuccess, GetGridSelectLayerError,
  DelayedActionBy1, GetBasemaps, GetMetaData, ToastUserNotification,
  SetSelectedFeatureSections, ConcatSelectedFeatureSections,
  GetFeatureData, AppMapViewLoadFinished, CheckLayerDisplay,
  SearchEngineerDrawings,
  GetEngDrawingGeometry,
  SearchEngineerDrawingsByNum,
  SearchEngineerDrawingsByProj,
  OpenEngDrawing, OpenMapView,
  RenewArcGisToken, RenewArcGisTokenSuccess,
  RenewArcGisTokenError, SearchCCTV, SearchCCTVNotes,
  SetCCTVNotes, SetCCTV, SearchEngineerDrawingsByNumType,
  ToolboxMailMergeUpdateResultCountSuccess,
  ToolboxMailMergeArea, ToolboxMailMergeBuffer,
  ToolboxMailMergeSelectedParcels, ToolboxMailMergeToggleParcel,
  RefreshDisplayedGeoJson, SearchSuccess, SearchError, SelectCCTV,
  LaunchStreetView, SetFeatureRasterHighlight, GetCoordsByObjectId,
  InvalidateGridCache, SetEditPermission, SetMaxAssetId, SetShowSpinner,
  SaveEditFeature, UpdateEditFeature, UpdateEditFeatureGeometry, DeleteEditFeature, GetMaxAssetId, GetSnapGeometry, GetSnapGeometryError,
  GetSnapGeometrySuccess, GetMaxAssetIdError, SetEditFeatureFields, GetEditFeatureFieldsError, GetAppSettingsError, SetAppSettings,
  RefreshActiveLegends, CheckRelatedTables, SetRelatedRecords, SetInspectionAttachments, GetFeatureAttachments, SetFeatureAttachments,
  ShowThumbnails, GetRelatedTables, ConcatRelatedRecords, GetRelTblName, SetRelatedAttachments, GetAttachment, GetAttachments,
  SetEditRequiredFields, GetEditRequiredFieldsError, SetEditReadOnlyFields, GetEditReadOnlyFieldsError, SetExternalFeature, ToggleAlert,
  GetFlowWorksData,
  SearchPostingPlans,
  SearchPostingPlansByNum,
  SetCAD,
  SetOutstandingED,
  GetCAD, ToolboxMailMergeToggleParcelAtCoordinate, GetMailMergeByProperty, GetToolsPermissions, SetToolsPermissions, GetOutstandingED, PopulationSelectedArea, PopulationSetState,
  SetShowSearchSpinner
} from './application.action';
import { SetGeoJsonProperty } from '../properties/properties.action';
import {
  LocationCoordinate,
  UserNotification, ArcGisTokenAboutToExpire,
  ApplicationStatus, ToolboxStatus, AttachmentsPayload
} from './application.state';
import { SearchService, PropertiesService, getApplicationState } from 'src/app/services';
import { FeatureLayerDataNames as FLDN } from '../../models/featurelayer-datanames';

import { State, WmrpResults } from 'src/app/state-management';

import {
  ArcGisToken, SetArcGisToken,
  DnvMarker, SetMarkers, DnvLatLng, DnvMapInfo, SetMapGeoJsonLayers,
  ZoomToGeoJsonLayer, LoadLayersSuccess, Layer, LayerState,
  SetMapFeatureLayers, CenterMap, DnvFeatureLayer, DnvBasemap,
  SetBaseMaps, SetMapBasemaps, SetMetaData,
  SetSurroundingFeatureList, ToggleFeaturePanel,
  SelectFeature, FeatureClicked, SetSelectedFeatureLayer,
  SetSelectedItem, DnvMapActionType, DeleteToolPolygon,
  SetEditFeaturesPermission,
  SetActiveLegendLayers,
  DnvLayerActionType,
  LayerInfo
} from 'dnv-lib';
import { ActivationEnd, Router } from '@angular/router';
import { BasemapsService, ConfigService, LayersService, MetadataService, ArcGisService, EditFeatureService } from 'src/app/services';
import { FeaturesService } from '../../services/features.service';
import { AppSettingsService } from 'src/app/services/appsettings.service';
import { DatePipe } from '@angular/common';
import { NgxGalleryAnimation } from '@vinlos/ngx-gallery';
import { parseDrawInfo } from 'dnv-lib';
import { LatLng } from 'leaflet';
import { saveAs } from 'file-saver';



interface Symbol {
  type: string;
  style: string;
  color: number[];
  width: number;
}

function formatDate(key: string, value: string): string {
  if (
    (key.toLowerCase().indexOf('date') > -1 && value.length > 4) ||
    (key.toLowerCase().indexOf('met input') > -1 && Number.isInteger(Number(value)))
  ) {
    if (value.length >= 10) { // only convert unix timestamp
      const convertedDate = new Date(Number(value));
      if (convertedDate.toString().toLowerCase().indexOf('invalid') === -1) {
        value = convertedDate.toString().substring(4, convertedDate.toString().indexOf('GMT')).trim();
        // strip out time, see GT-669
        const lastSpace = value.lastIndexOf(' ');
        value = value.substring(0, lastSpace);
      }
    }
  }

  if (value === '-99') {
    value = 'UNKNOWN';
  }
  return value;
}

function formatLength(key: string, value: string): string {
  let unit = ' m';
  let lenVal = Number(value).toFixed(2);
  if (key.toLowerCase().indexOf('size') > -1) {
    unit = ' mm';
    lenVal = value;
  }
  if (Number(value) === -99) {
    return 'UNKNOWN';
  } else {
    if (Number(lenVal) === 0) {
      return '—';
    }
    return Number(lenVal) + unit;
  }

}

function formatArea(key: string, value: string): string {
  if (Number(value) === -99) {
    return 'UNKNOWN';
  } else {
    if (key.toLowerCase() === 'area_ha') {
      return Number(value).toFixed(2) + ' ha';
    } else {
      return Number(value).toFixed(2) + ' m<sup>2</sup>';
    }
  }
}

function* generateSequence(start: number, end: number) {
  for (let i = start; i <= end; i++) yield i;
}

@Injectable()
export class ApplicationEffects implements OnDestroy {

  private ngUnsubscribe: Subject<void> = new Subject();
  appSettings: any;

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  delayedAction$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.DelayedAction),
    delay(0),
    // tslint:disable-next-line: deprecation
    mergeMap((action: DelayedAction) => {
      return action.payload;
    })
  ));


  delayedActionBy1$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.DelayedActionBy1),
    delay(1000),
    mergeMap((action: DelayedActionBy1) => {
      return action.payload;
    })
  ));


  getLayers$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetLayers),
    switchMap((action: GetLayers) =>
      this.layersService.getLayers()
    ),
    // tslint:disable-next-line: deprecation
    mergeMap((data: Layer[]) => [
      new LoadLayersSuccess(data)
    ])
  ));


  getBasemaps$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetBasemaps),
    switchMap((action: GetBasemaps) =>
      this.basemapsService.getBasemaps()
    ),
    mergeMap((data: DnvBasemap[]) => [
      new SetBaseMaps(data),
      new SetMapBasemaps(data)
    ])
  ));


  GetToolsPermissions$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetToolsPermissions),
    switchMap((action: GetToolsPermissions) =>
      this.editFeatureService.getToolsPermissions()
    ),
    // tslint:disable-next-line: deprecation
    mergeMap((data: Layer[]) => [

      new SetToolsPermissions(data)
    ])
  ));

  /*   
    getSnapGeometry$ = createEffect((): any => this.actions$.pipe(
      ofType(ApplicationActionType.GetSnapGeometry),
      switchMap((action: GetSnapGeometry) =>
        this.featureService.getSnapGeometry(action.payload)
      ),
      mergeMap((data: DnvBasemap[]) => [

      ])
    ); */


  editFeatureLayer(layers: Layer[], layerId: number, featureLayerId: number): DnvFeatureLayer {
    let efl: DnvFeatureLayer = null;

    const layer = layers.find(l => l.id === layerId);
    if (layer) {
      const featureLayer = layer.featureLayers.find(fl => fl.featureLayerId === featureLayerId);
      if (featureLayer) {
        efl = featureLayer;
      }
    }

    const featureLayer = Object.assign({}, efl, { type: 'Feature' });
    return featureLayer;
  }


  checkLayerDisplayEffect$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.CheckLayerDisplay),
    withLatestFrom(this.store$),
    map(([, store]) => {
      let layers: Layer[] = [];
      let toolActive = false;


      if (store.applicationReducer.toolboxStatus === ToolboxStatus.WMRP && store.wmrpState.wmrpResults.length > 0) {

        if (false && !store.wmrpState.selectedReplacementSchedule) {
          const hazardBoundaryLow = store.wmrpState.wmrpState.hazardBoundaryLow;
          const hazardBoundaryHigh = store.wmrpState.wmrpState.hazardBoundaryHigh;

          layers = layers.concat(
            store.layerState.layers
              .filter(l => ['WMRP_ANALYSIS_LAYERS'].includes(l.uid))
              .map(l => Object.assign({}, l, {
                featureLayers: l.featureLayers.filter(fl => ['WMRP_ANALYSIS'].includes(fl.uid)).map(fl => {


                  const defaultSymbol = {
                    type: 'esriSLS',
                    style: 'esriSLSSolid',
                    color: [
                      255,
                      0,
                      0,
                      155
                    ],
                    width: 10
                  };

                  const classBreakInfos = [
                    {
                      symbol: {
                        type: 'esriSLS',
                        style: 'esriSLSSolid',
                        color: [
                          255,
                          0,
                          0,
                          255
                        ],
                        width: 2
                      },
                      classMaxValue: hazardBoundaryLow
                    },
                    {
                      symbol: {
                        type: 'esriSLS',
                        style: 'esriSLSSolid',
                        color: [
                          255,
                          255,
                          0,
                          255
                        ],
                        width: 2
                      },
                      classMaxValue: hazardBoundaryHigh
                    },
                    {
                      symbol: {
                        type: 'esriSLS',
                        style: 'esriSLSSolid',
                        color: [
                          0,
                          0,
                          255,
                          255
                        ],
                        width: 2
                      },
                      classMaxValue: 999999
                    }
                  ];


                  const definitionExpression = `${this.appSettings['appConfig.gisdb']}${this.appSettings['appConfig.gisdb.wmrpprefix']}Run_reference='${store.wmrpState.selectedRun.fmeReference}'`;
                  const classBreaksRenderer = this.classBreakRenderer(0, this.appSettings['appConfig.gisdb'] + `${this.appSettings['appConfig.gisdb.wmrpprefix']}Analysis_value`, defaultSymbol, classBreakInfos, definitionExpression);
                  const symbology = Object.assign({}, (fl.symbology || {}), { timestamp: new Date().toISOString() });

                  return Object.assign({}, fl, {
                    classBreaksRenderer,
                    symbology
                  });
                })
              }))
          );
        }

        if (false && store.wmrpState.selectedReplacementSchedule) {

          const startYear = Number(store.wmrpState.selectedReplacementSchedule.startYear);
          const endYear = Number(store.wmrpState.selectedReplacementSchedule.endYear);

          layers = layers.concat(
            store.layerState.layers
              .filter(l => ['WMRP_SCHEDULE_LAYERS'].includes(l.uid))
              .map(l => Object.assign({}, l, {
                featureLayers: l.featureLayers.filter(fl => ['WMRP_SCHEDULE'].includes(fl.uid)).map(fl => {


                  const defaultSymbol = {
                    type: 'esriSLS',
                    style: 'esriSLSSolid',
                    color: [
                      0,
                      0,
                      0,
                      155
                    ],
                    width: 0.3
                  };

                  const classBreakInfos = [...generateSequence(startYear, endYear)].map((x, i) => {
                    return {
                      symbol: {
                        type: 'esriSLS',
                        style: 'esriSLSSolid',
                        color: [
                          [255, 0, 0, 255],
                          [255, 255, 0, 255],
                          [0, 255, 0, 255],
                          [0, 255, 255, 255],
                          [0, 0, 255, 255]
                        ][i % 5],
                        width: 2
                      },
                      classMaxValue: (x + 0.999)
                    };
                  });

                  const definitionExpression = `${this.appSettings['appConfig.gisdb']}SDE_ADMIN.WtrWRPSchedule.Schedule_reference='${store.wmrpState.selectedReplacementSchedule.fmeReference_Schedule}'`;
                  const classBreaksRenderer = this.classBreakRenderer(1, this.appSettings['appConfig.gisdb'] + 'SDE_ADMIN.WtrWRPSchedule.Replacement_year', defaultSymbol, classBreakInfos, definitionExpression);
                  const symbology = Object.assign({}, (fl.symbology || {}), { timestamp: new Date().toISOString() });

                  return Object.assign({}, fl, {
                    classBreaksRenderer,
                    symbology
                  });
                })
              }))
          );

        }

      }


      if (store.applicationReducer.toolboxStatus === ToolboxStatus.ServiceConnections) {
        toolActive = toolActive || true;

        // SC toolbox shows these 4 layers w all child feature layers visible, an opacity of 1 and no filter
        layers = layers.concat(
          store.layerState.layers
            .filter(l => ['CAD_ROW_AND_EASEMENTS', 'SAN_NETWORK', 'STMN_NETWORK', 'WTR_NETWORK'].includes(l.uid))
            .map(l => Object.assign({}, l, {
              featureLayers: l.featureLayers.map(fl => this.fullyVisibleDnvFeatureLayer(fl))
            }))
        );

      }

      if (store.applicationReducer.toolboxStatus === ToolboxStatus.CCTV) {
        toolActive = toolActive || true;

        // CCTV toolbox shows a single layer w all child feature layers visible, an opacity of 1 and no filter
        layers = layers.concat(
          store.layerState.layers
            .filter(l => ['Data_CCTV'].includes(l.uid))
            .map(l => Object.assign({}, l, {
              featureLayers: l.featureLayers.map(fl => this.fullyVisibleDnvFeatureLayer(fl))
            }))
        );

      }

      let featureLayers: DnvFeatureLayer[] = this.myFlatMap(layers.map(l => l.featureLayers));
      let snapLayers: DnvFeatureLayer[] = [];

      // Edit feature tool turns on specific feature layers not entire layers
      if (store.mapState.editFeaturesPermission && store.mapState.editFeaturesPermission.layerId) {
        toolActive = toolActive || true;

        const efl = this.editFeatureLayer(store.layerState.layers
          , store.mapState.editFeaturesPermission.layerId
          , store.mapState.editFeaturesPermission.featureLayerId);
        if (efl) {
          let symbolCopy;
          if (store.legendState.editFeatureLayerSymbology) {
            symbolCopy = (store.legendState.editFeatureLayerSymbology as any).symbology;
          } else {
            symbolCopy = parseDrawInfo(store.mapState.editFeaturesPermission as DnvFeatureLayer);
            if (symbolCopy !== null) {
              symbolCopy.timestamp = store.mapState.editFeaturesPermission?.symbology?.timestamp;
            }
          }

          const modEfl = Object.assign({}, efl, {
            drawingInfo: store.mapState.editFeaturesPermission.drawingInfo,
            url: store.mapState.editFeaturesPermission.url,
            writeUrl: store.mapState.editFeaturesPermission.write_Url,
            symbology: symbolCopy
          })
          featureLayers.push(modEfl);
        }

        store.mapState.editFeaturesPermission.snapLayers.forEach((snapLayer: any) => {
          const sfl = this.editFeatureLayer(store.layerState.layers
            , snapLayer.layerId
            , snapLayer.featureLayerId);
          if (sfl) {
            // snapLayers.push(sfl);
            featureLayers.push(sfl);
          }
        });
      }

      let activeFeatureLayers: DnvFeatureLayer[] = [];
      if (store.applicationReducer.status !== ApplicationStatus.Toolbox
        || (store.applicationReducer.status === ApplicationStatus.Toolbox && store.applicationReducer.toolboxStatus === ToolboxStatus.WMRP)
        || (store.applicationReducer.status === ApplicationStatus.Toolbox && store.applicationReducer.toolboxStatus !== ToolboxStatus.EditFeatures)
        || (store.applicationReducer.toolboxStatus === ToolboxStatus.EditFeatures && store.applicationReducer.editFeatureShowActiveLayer)) {
        activeFeatureLayers = this.layerList(store.mapState.zoomLevel, store.layerState);

        activeFeatureLayers.forEach(afl => {

          if (!featureLayers.some(fl => fl.featureLayerId === afl.featureLayerId)) { // <- need different featureLayerId TODO
            featureLayers = featureLayers.concat(afl);
          }
        });
      }

      if (store.applicationReducer.toolboxStatus === ToolboxStatus.AssetFinder) {
        const featureLayerId = store.applicationReducer.searchAsset.featureLayerId;
        store.layerState.layers.find(l => {
          l.featureLayers.some(f => {
            if (f.featureLayerId === featureLayerId) {
              featureLayers.push(f);
            }
          })
        });

      }

      // return this.layerList(store.mapState.zoomLevel, store.layerState);
      // return this.myFlatMap(layers.map(l => l.featureLayers));
      return { featureLayers, snapLayers };
    }),
    mergeMap((data) => {
      // if (data.snapLayers.length == 0) {
      //   return [
      //     new SetMapFeatureLayers(data.featureLayers)
      //   ]
      // } else {
      return [
        new SetMapFeatureLayers(data.featureLayers)
      ]
      //}
    })
  ));


  fullyVisibleDnvFeatureLayer(fl: DnvFeatureLayer): DnvFeatureLayer {
    return Object.assign({}, fl, { isVisible: true, opacity: 1, fieldFilters: null, whereClause: '1=1' });
  }

  myFlatMap(list: any[]): any {
    return list.reduce((accumulator, currentValue) => accumulator.concat(currentValue), []); // Poor man's FlatMap
  }

  layerList(zoomLevel: number, layerState: LayerState): DnvFeatureLayer[] {
    const activeFeatureLayers = layerState.layers
      .filter(l => l.type === 0) // Only keep active layers
      .filter(l => zoomLevel >= l.minZoom) // Only keep an active layer if the zoom level is high enough
      .map(l => l.featureLayers);
    return this.myFlatMap(activeFeatureLayers);
  }

  // activeLayers(activeLayers: DnvFeatureLayer[]): any {
  //   return activeLayers.map(a => a.featureLayerId);
  // }





  search$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.Search),
    debounceTime(200), // Prevent successive search actions from hitting the server.
    filter((action: Search) => {
      if (!action.payload) {
        return false; // payload is null
      } else {
        // there must be something to search for
        return (action.payload.search.searchedItem.assetId || action.payload.search.searchedItem.name).length > 0;
      }
    }),
    switchMap((action: Search) => this.searchService.getGeoInfo(action.payload.search)
      .pipe(
        mergeMap((data: any) => {
          const url = new Date().toISOString(); // create a unique url for each search result
          return [
            new SearchSuccess({
              search: action.payload.search,
              success:
              {
                url,
                json: data
              }
            }),
            new DelayedAction([
              new RefreshDisplayedGeoJson(),
              new DelayedActionBy1([new ZoomToGeoJsonLayer(url)]),
              new SetShowSearchSpinner(false)
            ])
          ];
        }),
        catchError((error: HttpErrorResponse) => {
          return of(new SearchError({
            search: action.payload.search,
            error
          }));
        })
      )
    )
  ));



  searchError$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchError),
    mergeMap((dataNames: any) => {
      const actions: Action[] = [];
      actions.push(
        new ToastUserNotification({
          type: 'fail',
          title: 'The operation failed',
          message: 'Your search has no associated information',
          options: {
            disableTimeOut: false,
            closeButton: true,
            enableHtml: true,
            timeOut: 5000
          }
        }));
      return actions;
    })
  ));


  searchReset$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchReset),
    mergeMap((data: any) => {
      const actions: Action[] = [];
      actions.push(new RefreshDisplayedGeoJson());
      return actions;
    })
  ));

  EDSearch$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetEngDrawingGeometry),
    debounceTime(200), // Prevent successive search actions from hitting the server.
    filter((action: GetEngDrawingGeometry) => {
      if (!action.payload.searchedItem.name) {
        return false; // payload is null
      } else {
        // there must be something to search for
        return action.payload.searchedItem.name.length > 0;
      }
    }),
    switchMap((action: GetEngDrawingGeometry) => this.searchService.getEDGeoInfo(action.payload.searchedItem.name)
      .pipe(

        mergeMap((data: any) => {
          const url = new Date().toISOString(); // create a unique url for each search result
          const actions: Action[] = [];
          if (data.crs === null) {
            actions.push(
              new ToastUserNotification({
                type: 'fail',
                title: 'The operation failed',
                message: 'Your search has no associated information',
                options: {
                  disableTimeOut: false,
                  closeButton: true,
                  enableHtml: true,
                  timeOut: 5000
                }
              }));
          } else {
            actions.push(
              new SearchSuccess({
                search: action.payload,
                success:
                {
                  url,
                  json: data
                }
              })
            );

            actions.push(
              new DelayedAction([
                new RefreshDisplayedGeoJson(),
                new DelayedActionBy1([new ZoomToGeoJsonLayer(url)])
              ])
            );
          }

          return actions;
        }
        )
      )
    )
  ));



  searchCoordinates$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchCoordinates),
    switchMap((action: SearchCoordinates) => {
      return this.searchService.getLocationCoordinates(action.payload).pipe(
        withLatestFrom(this.store$),
        mergeMap(([data, store]: [LocationCoordinate, State]) => {
          const latLng: DnvLatLng = {
            lat: data.lat
            , lng: data.lng
          };
          const sfc: DnvMapInfo = {
            latlng: latLng,
            mapSizeInPixel: '803, 600',
            mapBounds: {
              northWestBound: store.mapState.northWestBound,
              southEastBound: store.mapState.southEastBound
            },
          };

          return [
            new SetMarkers([]),
            new SearchCoordinatesSuccess({
              ...action.payload,
              updatedBy: 'Input',
              success: data
            }),
          ];
        }),
        catchError((error: HttpErrorResponse) => {
          return of(new SearchCoordinatesError({
            ...action.payload,
            updatedBy: null,
            error
          }));
        })
      );
    })
  ));

  getDBLink$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetDBLink),
    switchMap((action: any) => this.searchService.getDbLink(action.payload.num.name, action.payload.type)
      .pipe(
        mergeMap((data: any) => this.searchService.getShape(data.gisLink)
          .pipe(
            mergeMap((data: any) => {
              const url = new Date().toISOString(); // create a unique url for each search result
              return [
                new SearchSuccess({
                  search: action.payload,
                  success:
                  {
                    url,
                    json: data
                  }
                }),
                new DelayedAction([
                  new RefreshDisplayedGeoJson(),
                  new DelayedActionBy1([new ZoomToGeoJsonLayer(url)]),
                  new SetShowSearchSpinner(false)
                ])
              ];
            }
            )
          )
        )
      )
    )
  ));

  getShape$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetShape),
    switchMap((action: any) => this.searchService.getShape(action.payload)
      .pipe(
        mergeMap((data: any) => {
          return [
            new SetGeoJsonProperty({
              url: action.payload,
              json: data
            }),
            new DelayedAction([
              new RefreshDisplayedGeoJson(),
              new DelayedActionBy1([new ZoomToGeoJsonLayer(action.payload)])
            ])
          ];
        }
        )
      )
    )
  ));


  setFilterAOIShape$ = createEffect((): any => this.actions$.pipe(
    ofType(DnvMapActionType.SetFilterAOIShape),
    switchMap((action: Action) => {
      return [new InvalidateGridCache(null)];
    })
  ));


  gridSelectLayerEffect$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GridSelectLayer),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [GridSelectLayer, State]): any => {

      const dnvFeatureLayer: DnvFeatureLayer = (action as GridSelectLayer).payload.dnvFeatureLayer;
      // get new layer if layer not in gridSelectLayerCache or if WMRP then always get new layer
      if (dnvFeatureLayer && (!store.applicationReducer.gridSelectLayerCache.has(dnvFeatureLayer.uid) || dnvFeatureLayer.uid!.indexOf("WMRP") > -1)) {
        let geometry: any[] = [];
        if (store.mapState.filterAOIMode.shape && store.mapState.filterAOIMode.shape.geometry) {
          geometry = store.mapState.filterAOIMode.shape.geometry.coordinates;
        }

        return this.layersService.getGridSelectLayer(dnvFeatureLayer, geometry).pipe(
          mergeMap((data: any) => {
            return [
              new GetGridSelectLayerSuccess({
                dnvFeatureLayer,
                success: data
              })
            ];
          }),
          catchError((error: HttpErrorResponse) => {
            return of(new GetGridSelectLayerError({
              dnvFeatureLayer,
              error
            }));
          })
        );
      }
      else {
        return [];
      }
    })
  ));


  checkTokenOnMapAction$ = createEffect((): any => this.actions$.pipe(
    ofType(...(Object).values(DnvMapActionType)),
    throttleTime(1000),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [Action, State]) => {

      // don't renew the token unless it is about to expire or already expired
      if (ArcGisTokenAboutToExpire(store.applicationReducer.arcGisToken)) {
        return [new RenewArcGisToken({ delayedActions: [] })];

      }
      else {
        return [];
      }

    })
  ));

  // Similar to ArcgisInterceptor
  renewArcGisTokenEffect$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.RenewArcGisToken),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [RenewArcGisToken, State]): any => {

      // don't renew the token unless it is about to expire or already expired
      if (ArcGisTokenAboutToExpire(store.applicationReducer.arcGisToken)) {
        return this.arcGisService.RenewArcGisToken().pipe(
          mergeMap((data: ArcGisToken) => {
            const actions: Action[] = [];
            // update the token before performing the rest of the actions
            actions.push(
              new RenewArcGisTokenSuccess({
                delayedActions: action.payload.delayedActions,
                success: data
              })
            );
            actions.push(
              new SetArcGisToken(data)
            );
            actions.push(...action.payload.delayedActions);
            return actions;
          }),
          catchError((error: HttpErrorResponse) => {
            return of(new RenewArcGisTokenError({
              delayedActions: [],
              error
            }));
          })
        );
      }
      else {
        return [];
      }

    })
  ));


  searchCoordinatesSuccess$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchCoordinatesSuccess),
    mergeMap((action: SearchCoordinatesSuccess) => {

      let marker: DnvMarker;
      const latLng: DnvLatLng = {
        lat: action.payload.success.lat,
        lng: action.payload.success.lng
      };

      marker = {
        url: new Date().toISOString(), // create a unique url
        centerPoint: latLng,
        popup: '',
        popupOptions: { maxWidth: 400 },
        tooltip: action.payload.name,
        tooltipOptions: {
          permanent: false,
          direction: 'right',
          offset: [14, -20],
          className: 'map-tooltip'
        },
        clickEvent: true,
        id: action.payload.name,
        isActive: false,
        activeIcon: {
          iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
          className: 'myDivIconSelected',
          iconSize: [35, 60],
        },
        icon: {
          iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
          className: 'myDivIcon',
          iconSize: [35, 60],
        }
      };

      let ltopid = action.payload.success.ltopid;
      if (ltopid === undefined) {
        ltopid = '_unknown_pid_';
      } else if (ltopid.length === 0) {
        ltopid = '_unknown_pid_';
      }

      return [
        new SetMarkers([marker]),
        new CenterMap(latLng),
        new SetShowSearchSpinner(false)
      ];
    })
  ));

  getDataNames$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetDataNames),
    switchMap((action: any) => {
      return this.metadataService.getDataNames(action.payload);
    }),
    mergeMap((dataNames: any) => {
      const dNames = this.myFlatMap(dataNames.map((d: FLDN) => d.dataName));
      return [
        new GetMetaData(dNames)
      ];
    })
  ));

  getMetadata$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetMetaData),
    switchMap((action: any) => this.metadataService.getMetadata(action.payload)
      .pipe(
        mergeMap((data: any) => {
          return [
            new SetMetaData(data)
          ];
        }
        )
      )
    )
  ));

  toastUserNotification$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.ToastUserNotification),
    map((action: ToastUserNotification) => {
      const notification: UserNotification = action.payload;
      if (notification) {
        switch (notification.type) {
          case 'success':
            this.toastr.success(notification.message, notification.title, notification.options || {});

            break;
          case 'info':
            this.toastr.info(notification.message, notification.title, notification.options || {});

            break;
          case 'warning':
            this.toastr.warning(notification.message, notification.title, notification.options || {});

            break;

          case 'error':
            this.toastr.error(notification.message, notification.title, notification.options || {});

            break;
          default:
            this.toastr.error(
              notification.message || 'Please raise a suport ticket with information about what you were doing in the application!'
              , notification.title || 'Something went wrong...', notification.options || {});
            break;
        }
      } else {
        this.toastr.error(
          'Please raise a suport ticket with information about what you were doing in the application!',
          'Something went wrong...', {});
      }
    })
  ),
    { dispatch: false });


  identifySurroundingFeature$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.IdentifySurroundingFeature,
      ApplicationActionType.IdentifySurroundingFeaturePost),
    withLatestFrom(this.store$),
    switchMap(([action, storeState]) => {
      if (action.type.indexOf('Post') > -1) {
        return this.featureService.identifySurroundingFeaturePost((action as any).payload).pipe(
          catchError((error) =>
            of({ error })
          ),
          map((data) => ({ data, layerState: storeState.layerState, mapState: storeState.mapState, applicationState: storeState.applicationReducer }))
        )
      } else {
        return this.featureService.identifySurroundingFeature((action as any).payload).pipe(
          catchError((error) =>
            of({ error })
          ),
          map((data) => ({ data, layerState: storeState.layerState, mapState: storeState.mapState, applicationState: storeState.applicationReducer }))
        )
      }
    }),
    mergeMap((data: any) => {
      if (data.data.error) {
        return [
          new ToastUserNotification({
            type: 'error',
            title: data.data.error.statusText,
            message: data.data.error.message,
            options: {
              disableTimeOut: true,
              closeButton: true
            }
          })
        ];
      } else if (data.data.length === 1) {
        // console.log('data.data.length === 1', data);

        const layer = data.layerState.layers.find((l: any) => l.name === data.data[0].name);
        let highlightUrl = data.data[0].url;
        if (layer) {
          highlightUrl = data.data[0].url + layer.whereClause;
        }

        const dispatchActions = [
          new SetSurroundingFeatureList(null),
          new SetRelatedRecords(null),
          new GetFeatureData({ featureUrl: `${this.configService.webApiEndpoint}getFeatureData?url=${data.data[0].url + encodeURIComponent('/query?f=json&outFields=*&returnGeometry=true&outSR=4326&objectIds=') + data.data[0].objectId}`, url: data.data[0].url }), // NEEDED?

          new SetSelectedFeatureLayer({
            url: data.data[0].url,
            writeUrl: data.data[0].writeUrl,
            // objectId: data.data[0].objectId, // ???
            allow_inspections: data.data[0].allowInsp,
            inspEndPoint: data.data[0].inspEndPoint
          }),

          new FeatureClicked({
            url: data.data[0].url,
            writeUrl: data.data[0].writeUrl,
            objectId: data.data[0].objectId,
            tableLayers: null,
            assetId: data.data[0].assetId,
            excludeFeatureInfo: data.mapState.excludeFeatureInfo
          }),
          // new SetHighlightFeature({ url: highlightUrl, objectId: data.data[0].objectId }), // feature layer highlight

          // raster layer highlgiht
          // new GetCoordsByObjectId({ url: data.data[0].url, objectId: data.data[0].objectId })
        ];

        if (data.applicationState.toolboxStatus === ToolboxStatus.CCTV) {
          dispatchActions.push(new SearchCCTV(data.data[0].assetId));
          dispatchActions.push(new GetCoordsByObjectId({ url: data.data[0].url, objectId: data.data[0].objectId, zoom: true }));
        } else {
          dispatchActions.push(new GetCoordsByObjectId({ url: data.data[0].url, objectId: data.data[0].objectId }));
        }

        return dispatchActions;

      } else if (data.data.length < 1) {
        // console.log('data.data.length < 1', data);
        return [
          new SetSurroundingFeatureList(null),
          new GetFeatureData(null)
        ];
      } else {
        // console.log('else', data);
        return [
          new SetSelectedItem(null),
          new SetSurroundingFeatureList(data.data)
        ];
      }
    })
  ));

  getFeatureData$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetFeatureData),
    withLatestFrom(this.store$),
    switchMap(([action, storeState]) =>
      this.featureService.getGisFeatureData((action as any).payload?.featureUrl).pipe(
        // do not remove this, 'causes errors when payload is null
        catchError((error) =>
          of({ error })
        ),
        map((data: any) => ({ data, url: (action as any).payload?.url, layerState: storeState.layerState })),
      )
    ),
    mergeMap((data: any) => {

      if (data.data && data.data.error) { // "Cannot read property 'toLowerCase' of undefined" ???
        return [
          new ToggleFeaturePanel()
        ];
      } else {
        // replace label with alias
        let metaDictionary: any[] = [];
        let subTypeField: string = null;
        let subTypes: { id: number, name: string }[] = [];
        data.layerState.layers.forEach((layer: any) => {
          layer.featureLayers.forEach((featureLayer: any) => {
            const urlMap = data.url.substring(data.url.indexOf('rest/services'), data.url.length);
            const flMap = featureLayer.url.substring(featureLayer.url.indexOf('rest/services'), featureLayer.url.length);
            if (urlMap === flMap) {
              metaDictionary = featureLayer.meta;
              subTypeField = featureLayer.subTypeField;
              subTypes = featureLayer.subTypes;
            }
          });
        });

        let lookupField: any[];
        const generalInfo: Array<[string, string]> = [];
        const assetInfo: Array<[string, string]> = [];
        let title = 'General Information';
        // tslint:disable-next-line: prefer-for-of
        if (data.data) {
          for (let i = 0; i < data.data.length; i++) {
            const keyVal = data.data[i];
            lookupField = metaDictionary.filter(a => a.name === keyVal[0]);
            if (subTypeField != null && subTypeField === keyVal[0] && subTypes != null && subTypes.length > 0) {
              const typeName = subTypes.filter(subType => subType.id?.toString() === keyVal[1]);
              if (typeName != null && typeName.length > 0) {
                keyVal[1] = typeName[0].name;
              }
            }

            if (lookupField && lookupField.length > 0) {
              const lf = lookupField[0];
              // keyVal[0] = lf.alias;
              if (lf && lf.domain && lf.domain.length > 0) {
                const valueName = lf.domain.filter((domain: { name: string, code: string }) => domain.code === keyVal[1]);
                if (valueName && valueName.length > 0) {
                  keyVal[1] = valueName[0].name;
                }
              }

              const lengthFields = ['shape.stlength()', 'inv_elev', 'manhole_rim_elev', 'manhole_entry_size', 'offset', 'asb_length', 'asb_slope', 'calc_slope', 'up_elev', 'dn_elev', 'conn_chain', 'pty_offset', 'am_diameter', 'am_rise', 'am_span', 'flume_up_elev', 'flume_dn_elev', 'flume_asb_length', 'flume_asb_slope', 'cl_length', 'bf_length', 'sw_length', 'totallength', 'totalarea', 'totalwidth'];

              if (lf.name.toLowerCase().includes('am_') || lf.name.toLowerCase().includes('asset')) {
                // if (lf.name.toLowerCase().includes('am_size')) {
                //   assetInfo.push([lf.alias, formatLength(lf.alias, keyVal[1])]);
                // } else {
                assetInfo.push([lf.alias, formatDate(lf.alias, keyVal[1])]);
                // }
              } else if (lf.name.toLowerCase().includes('shape.starea') || lf.name.toLowerCase().includes('deckarea')) {
                assetInfo.push([lf.alias, formatArea(lf.alias, keyVal[1])]);
              } else if (lengthFields.includes(lf.name.toLowerCase())) {
                assetInfo.push([lf.alias, formatLength(lf.alias, keyVal[1])]);
              }
              else {
                if (lengthFields.includes(lf.name.toLowerCase())) {
                  generalInfo.push([lf.alias, formatLength(lf.alias, keyVal[1])]);
                }
                else {
                  generalInfo.push([lf.alias, formatDate(lf.alias, keyVal[1])]);
                  if (lf.name.toLowerCase().indexOf('analysis') > -1) {
                    title = 'Analysis Results';
                  } else if (lf.name.toLowerCase().indexOf('schedule') > -1) {
                    title = 'Schedule Results';
                  }
                }

              }
            }
          }
          if (generalInfo.length > 0) {
            const objId = this.getKeyValue(data.data, 'OBJECTID', '');
            const assetId = this.getKeyValue(data.data, 'asset_id', 'assetid');
            const actions = [];
            if (assetInfo.length === 0) {
              let fw: string = null;
              generalInfo.forEach(attr => {
                if (attr[0] === 'Station ID') {
                  fw = attr[1];
                  actions.push(new SetExternalFeature({ message: 'Accessing Flow Works...', pending: true }));
                  actions.push(new GetFlowWorksData(`${this.configService.webApiEndpoint}getFlowWorksData?stationId=` + fw));
                }
              });

              actions.push(new SelectFeature(data.data));
              actions.push(new SetSelectedFeatureSections([{
                title: 'General Information',
                kvPair: generalInfo
              }]));
              actions.push(new CheckRelatedTables({ url: data.url, objectId: objId }));
              actions.push(new SearchCCTV(assetId));
              return actions;
            }
            else { // (assetInfo.length > 0)
              if (title.toLowerCase().indexOf('general') > -1) {
                return [
                  new SelectFeature(data.data),
                  new SetSelectedFeatureSections([{
                    title: 'Asset Information',
                    kvPair: assetInfo
                  }]),
                  new ConcatSelectedFeatureSections({
                    title: title,
                    kvPair: generalInfo
                  }),
                  new CheckRelatedTables({ url: data.url, objectId: objId }),
                  new SearchCCTV(assetId)
                ];
              } else {
                // wmrp analysis or schedule results
                // GT-556 results go before 'asset info'
                return [
                  new SelectFeature(data.data),
                  new SetSelectedFeatureSections([{
                    title: title,
                    kvPair: generalInfo
                  }]),
                  new ConcatSelectedFeatureSections({
                    title: 'Asset Information',
                    kvPair: assetInfo
                  }),

                  new CheckRelatedTables({ url: data.url, objectId: objId }),
                  new SearchCCTV(assetId)
                ];
              }

            }
          }
          else { // (generalInfo.length === 0)
            const objId = this.getKeyValue(data.data, 'OBJECTID', '');
            const assetId = this.getKeyValue(data.data, 'asset_id', 'assetid');
            if (assetInfo.length > 0) {
              return [
                new SelectFeature(data.data),
                new SetSelectedFeatureSections([{
                  title: 'Asset Information',
                  kvPair: assetInfo
                }]),
                new CheckRelatedTables({ url: data.url, objectId: objId }),
                new SearchCCTV(assetId)
              ];
            } else if (data.data) {
              // for Edit Feature
              return [
                new SelectFeature(data.data)
              ]
            }
          }
        }

        return [];
      }
    }),
    catchError((error) => {
      return of(new ToastUserNotification({
        type: 'fail',
        title: 'The operation failed',
        message: 'We cannot retrieve feature information for this asset at the moment.',
        options: {
          disableTimeOut: false,
          closeButton: true,
          enableHtml: true,
          timeOut: 5000
        }
      }))
    }
    )
  ));



  appMapViewLoadFinished$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.AppMapViewLoadFinished),
    delay(0),
    // tslint:disable-next-line: deprecation
    mergeMap((action: AppMapViewLoadFinished) => {
      return [
        new DelayedActionBy1([...action.payload,
        new DelayedAction([
          new CheckLayerDisplay(),
          new RefreshActiveLegends()
        ])
        ])
      ];
    })
  ));


  SearchEngineerDrawings$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchEngineerDrawings),
    delay(0),
    mergeMap((action: SearchEngineerDrawings): any => {
      window.open('/engdrawings;areaOfInterest=' + encodeURIComponent(JSON.stringify(action.payload)), '_blank');
      return [];
    })
  ));


  SearchEngineerDrawingsByNum$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchEngineerDrawingsByNum),
    delay(0),
    mergeMap((action: SearchEngineerDrawingsByNum): any => {
      window.open('/engdrawings;numbers=' + encodeURIComponent(action.payload), '_blank');
      return [];
    })
  ));


  SearchEngineerDrawingsByNumType$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchEngineerDrawingsByNumType),
    delay(0),
    mergeMap((action: SearchEngineerDrawingsByNumType): any => {
      window.open('/engdrawings;numbers=' + encodeURIComponent(action.payload.drawNum)
        + ';type=' + action.payload.drawType, '_blank');
      return [];
    })
  ));


  SearchEngineerDrawingsByProj$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchEngineerDrawingsByProj),
    delay(0),
    mergeMap((action: SearchEngineerDrawingsByProj): any => {
      window.open('/engdrawings;projectName=' + encodeURIComponent(action.payload), '_blank');
      return [];
    })
  ));


  OpenEngDrawing$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.OpenEngDrawing),
    delay(0),
    mergeMap((action: OpenEngDrawing): any => {
      window.open(action.payload, '_blank');
      return [];
    })
  ));


  SearchPostingPlans$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchPostingPlans),
    delay(0),
    mergeMap((action: SearchPostingPlans): any => {
      window.open('/postingplans;areaOfInterest=' + encodeURIComponent(JSON.stringify(action.payload)), '_blank');
      return [];
    })
  ));


  SearchPostingPlansByNum$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchPostingPlansByNum),
    delay(0),
    mergeMap((action: SearchPostingPlansByNum): any => {
      window.open('/postingplans;numbers=' + encodeURIComponent(action.payload), '_blank');
      return [];
    })
  ));


  OpenMapView$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.OpenMapView),
    delay(0),
    mergeMap((action: OpenMapView): any => {
      this.router.navigate(action.payload.route, { queryParams: action.payload.queryParams });
      // if (action.payload) {
      // } else {
      //   this.router.navigate(['map']);
      // }
      return [];
    })
  ));


  SearchCCTVAfterSurroundingFeatureListIsSet$ = createEffect((): any => this.actions$.pipe(
    ofType(DnvMapActionType.SetSurroundingFeatureList),
    withLatestFrom(this.store$),
    map(([, store]) => {
      if (
        store.applicationReducer.toolboxStatus === ToolboxStatus.CCTV &&
        store.mapState.surroundingFeatureList && store.mapState.surroundingFeatureList.length > 0) {
        // thought it should be SurroundingFeature but something else
        return store.mapState.surroundingFeatureList.map((f: any) => f.assetId);
      }
      return [];
    }),
    mergeMap((assetList) => {
      if (assetList.length > 0) {
        return [
          new SearchCCTV(assetList.join('\',\''))
        ];

      } else {
        return [];
      }
    })
  ));


  LaunchStreetView$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.LaunchStreetView),
    delay(0),
    mergeMap((action: LaunchStreetView): any => {
      window.open('https://www.google.com/maps?layer=c&cbll=' + action.payload.lat + ',' + action.payload.lng, '_blank');
      return [];
    })
  ));


  GetCoordsByObjectId$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetCoordsByObjectId),
    switchMap((action: any) => this.searchService.getCoordinatesByObjectId(action.payload.url, action.payload.objectId)
      .pipe(
        mergeMap((data: any) => {
          // console.log(data);
          let shapeType = '';
          let shapeGeometry;
          if (data.geometryType === 'esriGeometryPolyline') {
            shapeType = 'LineString';
            shapeGeometry = data.features[0].geometry.paths[0];
          } else if (data.geometryType === 'esriGeometryPoint') {
            shapeType = 'Point';
            shapeGeometry = [data.features[0].geometry.x, data.features[0].geometry.y]
          } else {
            shapeType = 'Polygon';
            shapeGeometry = data.features[0].geometry.rings;
          }
          const frh = 'FeatureRasterGeometry' + new Date().toISOString();
          const actions = [
            new SetFeatureRasterHighlight({
              url: frh,
              json: {
                features: [{
                  geometry: {
                    coordinates: shapeGeometry,
                    type: shapeType
                  },
                  type: 'Feature'
                }]
              },
              style: {
                fillColor: '#222222',
                weight: 5,
                opacity: 0.6,
                color: '#ff9900',
                dashArray: '8',
                fillOpacity: 0.4
              }
            }),
            new DelayedAction([new RefreshDisplayedGeoJson()])
          ];
          if (action.payload.zoom && action.payload.zoom === true) {

            actions.push(
              new DelayedAction([
                new ZoomToGeoJsonLayer(frh)
              ])
            );
          }
          return actions;
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new ToastUserNotification({
            type: 'fail',
            title: 'The operation failed',
            message: 'Cannot get coordinates for object ' + action.payload.objectId,
            options: {
              disableTimeOut: false,
              closeButton: true,
              enableHtml: true,
              timeOut: 5000
            }
          }));
        })
      )
    )
  ));


  GetCoordsByAssetId$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetCoordsByAssetId),
    switchMap((action: any) => this.searchService.getCoordinatesByAssetId(action.payload.url, action.payload.assetId, action.payload.assetField)
      .pipe(
        mergeMap((data: any) => {
          // console.log(data);
          let shapeType = '';
          let shapeGeometry;
          if (data.geometryType === 'esriGeometryPolyline') {
            shapeType = 'LineString';
            shapeGeometry = data.features[0].geometry.paths[0];
          } else if (data.geometryType === 'esriGeometryPoint') {
            shapeType = 'Point';
            shapeGeometry = [data.features[0].geometry.x, data.features[0].geometry.y]
          } else {
            shapeType = 'Polygon';
            shapeGeometry = data.features[0].geometry.rings;
          }
          // const actions = [];
          const identifier = 'FeatureRasterGeometry' + new Date().toISOString();
          return [
            new SetFeatureRasterHighlight({
              url: identifier,
              json: {
                features: [{
                  geometry: {
                    coordinates: shapeGeometry,
                    type: shapeType
                  },
                  type: 'Feature'
                }]
              },
              style: {
                fillColor: '#222222',
                weight: 5,
                opacity: 0.6,
                color: '#ff9900',
                dashArray: '8',
                fillOpacity: 0.4
              }
            }),
            new DelayedAction([
              new RefreshDisplayedGeoJson(),
              new DelayedActionBy1([new ZoomToGeoJsonLayer(identifier)])
            ])
          ];
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new ToastUserNotification({
            type: 'fail',
            title: 'The operation failed',
            message: 'Cannot get coordinates for asset ' + action.payload.assetId,
            options: {
              disableTimeOut: false,
              closeButton: true,
              enableHtml: true,
              timeOut: 5000
            }
          }));
        })
      )
    )
  ));



  parseCCTVData(objectId: string, data: any[]): any {

    let video = null;
    let jobnumber = null;
    let extension = null;
    const attributes = data.filter(kv => { // filter out the OBJECTID and the kv with null values

      // with side effect here...
      if ('JOBNUMBER' === kv[0]) {
        jobnumber = kv[1];
        return false;
      }
      if ('EXTENSION' === kv[0]) {
        extension = kv[1];
        return false;
      }

      if ('OBJECTID' === kv[0]) {
        return false;
      }
      if (null === kv[1]) {
        return false;
      }
      if (kv[0].toLowerCase().indexOf('time') > -1) {
        kv[1] = new DatePipe('en-CA').transform(kv[1], 'mediumTime');
      }
      return true;
    });

    if (jobnumber && extension) {
      video = this.appSettings['appConfig.CCTVInspVideos'] + jobnumber + '.' + extension; // TODO parameterize
    }

    return {
      objectId,
      attrs: attributes,
      inspType: 'SANMN',
      video
    };
  }

  // tslint:disable-next-line: member-ordering

  SearchCCTV$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchCCTV),
    switchMap((action: any) => this.searchService.getCCTV(action.payload)
      .pipe(
        mergeMap((data: any) => {
          const objectIds = Object.keys(data);

          const actions = [
            new SelectCCTV(null),
            new SetCCTV(objectIds.map(objectId => this.parseCCTVData(objectId, data[objectId])))
          ];
          return actions;
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new ToastUserNotification({
            type: 'fail',
            title: 'The operation failed',
            message: 'Your search for ' + action.payload + ' failed.',
            options: {
              disableTimeOut: false,
              closeButton: true,
              enableHtml: true,
              timeOut: 5000
            }
          }));
        })
      )
    )
  ));


  // tslint:disable-next-line: member-ordering

  OnSetCCTV$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SetCCTV),
    mergeMap((action: SetCCTV) => {
      if (action.payload.length === 1) {
        return [new SelectCCTV(action.payload[0])];
      }
      return [];
    })
  ));

  // tslint:disable-next-line: member-ordering

  OnSelectCCTV$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SelectCCTV),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [any, State]) => {
      const actions = [];
      if (action.payload !== null) {
        actions.push(new SearchCCTVNotes(action.payload.objectId));
        actions.push(
          new DelayedAction([
            new ZoomToGeoJsonLayer(store.applicationReducer.featureRasterHighlight.url)
          ])
        );
      }

      return actions;

    }),
    // mergeMap((action: SelectCCTV) => {
    //   if (action.payload !== null) {
    //     return [new SearchCCTVNotes(action.payload.objectId)];
    //   }
    //   return [];
    // })
  ));


  // tslint:disable-next-line: member-ordering

  SearchCCTVNotes$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SearchCCTVNotes),
    mergeMap((action: any) => this.searchService.getCCTVRelatedData(action.payload)
      .pipe(
        mergeMap((data: any) => {
          const actions: any = [
            new SetCCTVNotes(this.parseCCTVDataNotes(action.payload, data))

          ];
          return actions;
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new ToastUserNotification({
            type: 'fail',
            title: 'The operation failed',
            message: 'Your search for ' + action.payload + ' failed.',
            options: {
              disableTimeOut: false,
              closeButton: true,
              enableHtml: true,
              timeOut: 5000
            }
          }));
        })
      )
    )
  ));


  parseCCTVDataNotes(objectId: string, data: any): any {
    const objectIds = Object.keys(data);
    const cctvData = objectIds.map(id => {
      const photographnumber = data[id].filter((kv: any[]) => 'PHOTOGRAPHNUMBER' === kv[0] && null !== kv[1]);
      const jobnumber = data[id].filter((kv: any[]) => 'JOBNUMBER' === kv[0]);
      let img: any[] = [];

      if (photographnumber.length === 1 && jobnumber.length === 1) {
        const photoNum = photographnumber.length > 9 ? photographnumber[0][1] : '0' + photographnumber[0][1];
        const imgPath = this.appSettings['appConfig.CCTVInspPhotos'] + jobnumber[0][1]
          + '_' + photoNum + '.jpg'; // TODO parameterize
        img = [{
          small: imgPath
          , medium: imgPath
          , big: imgPath
          , type: 'image'
        }];
      }

      return {
        title: id,
        kvPair: data[id].filter((kv: any[]) => null !== kv[1] && 'PHOTOGRAPHNUMBER' !== kv[0]),
        img
      };
    });

    return {
      cctvData,
      objectId,
      galleryOptions: [
        {
          width: '100%',
          height: '300px',
          imageArrowsAutoHide: true,
          thumbnails: false,
          imageArrows: false,
          thumbnailsColumns: 4,
          previewCloseOnEsc: true,
          imageAnimation: NgxGalleryAnimation.Slide
        },
        { breakpoint: 800, width: '100%', height: '300px', thumbnailsColumns: 3 },
        { breakpoint: 300, width: '100%', height: '200px', thumbnailsColumns: 2 },
        { "arrowPrevIcon": "fas fa-chevron-left", "arrowNextIcon": "fas fa-chevron-right" }
      ]
    };
  }


  ClearToolPolygon$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SetToolboxStatus),
    mergeMap((action: SetToolboxStatus) => {
      if (ToolboxStatus.Idle === action.payload) {
        return [new DeleteToolPolygon()];
      }
      return [];
    })
  ));

  // // DrawShapes MapType

  drawShapes$ = createEffect((): any => this.actions$.pipe(
    ofType(DnvMapActionType.DrawShapes),
    withLatestFrom(this.store$),
    map(([, store]) => {
      if (
        store.applicationReducer.status === ApplicationStatus.Toolbox &&
        (store.applicationReducer.toolboxStatus === ToolboxStatus.MailMerge || store.applicationReducer.toolboxStatus === ToolboxStatus.PopulationCalculator)) {
        // thought it should be SurroundingFeature but something else
        // return store.mapState.surroundingFeatureList.map((f: any) => f.assetId);
        const index = store.mapState.features.findIndex(f => f.geometry.type === 'tool-polygon');
        if (index >= 0) {
          return [{ store, geometry: store.mapState.features[index].geometry }]
        }
      }
      return [];
    }),
    mergeMap((assetList) => {
      if (assetList.length > 0) {
        if (assetList[0].store.applicationReducer.toolboxStatus === ToolboxStatus.MailMerge) {
          const tbmms = assetList[0].store.applicationReducer.toolboxMailMergeState;
          return [

            new ToolboxMailMergeArea(
              {
                url: 'MailMergeByPropertyOrShape' + new Date().toISOString(), // create a unique url
                json: {
                  features: [{
                    geometry: {
                      coordinates: assetList[0].geometry.coordinates,
                      type: 'Polygon' // Could be MultiPolygon if f.geometry.rings has more than one ring?
                    },
                    type: 'Feature'
                  }]
                },
                style: {
                  weight: 2,
                  opacity: 1,
                  color: 'black'
                }
              }
            ),
            new DelayedActionBy1([new DeleteToolPolygon(),
            new DelayedAction([new RefreshDisplayedGeoJson()])
            ])
          ];
        } else if (assetList[0].store.applicationReducer.toolboxStatus === ToolboxStatus.PopulationCalculator) {
          console.log('population calculator');
          return [
            new PopulationSelectedArea(
              {
                url: 'PopulationByPropertyOrShape' + new Date().toISOString(), // create a unique url
                json: {
                  features: [{
                    geometry: {
                      coordinates: assetList[0].geometry.coordinates,
                      type: 'Polygon' // Could be MultiPolygon if f.geometry.rings has more than one ring?
                    },
                    type: 'Feature'
                  }]
                },
                style: {
                  weight: 2,
                  opacity: 1,
                  color: 'green'
                }
              }
            ),
            new DelayedActionBy1([new DeleteToolPolygon(),
            new DelayedAction([new RefreshDisplayedGeoJson()])
            ])
          ];
        }
      } else {
        return [];
      }
    })
  ));

  getMailMergeByProperty$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetMailMergeByProperty),
    switchMap((action: any) => this.propertiesService.getPropertyByXY(action.payload.latlng)
      .pipe(
        switchMap((data: any) => {
          if (data.features && data.features.length > 0) {
            return this.searchService.getShape(data.features[0].attributes.DBLink)
              .pipe(
                switchMap((res: any) => {
                  return [new ToolboxMailMergeArea(
                    {
                      url: 'MailMergeByPropertyOrShape' + new Date().toISOString(), // create a unique url
                      json: {
                        features: [{
                          geometry: res.features[0].geometry,
                          type: 'Feature'
                        }]
                      },
                      style: {
                        weight: 2,
                        opacity: 1,
                        color: 'black'
                      },
                      latlng: action.payload.latlng
                    }
                  ),
                  new DelayedAction([new RefreshDisplayedGeoJson()])
                  ];
                })
              )
          }
          else {
            return [
              new ToastUserNotification({
                type: 'fail',
                title: 'Parcel not located',
                message: 'Your map click did not locate a parcel. Please try again.',
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            ];
          }
        }
        )
      )
    )
  ));


  // ToolboxMailMergeArea
  toolboxMailMergeArea$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.ToolboxMailMergeArea),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [ToolboxMailMergeArea, State]) => {

      if (store.applicationReducer.toolboxMailMergeState.selectionBuffer === 0) {
        return [
          this.createToolboxMailMergeBuffer(store.applicationReducer.toolboxMailMergeState.area.json.features[0].geometry.coordinates, action.payload.latlng),
          new DelayedAction([new RefreshDisplayedGeoJson()])
        ];
      }
      return this.searchService.getMailMergeBufferGeometry(
        store.applicationReducer.toolboxMailMergeState.area.json.features[0].geometry.coordinates,
        store.applicationReducer.toolboxMailMergeState.selectionBuffer).pipe(
          mergeMap((data: any) => {
            return [
              this.createToolboxMailMergeBuffer(data.geometries[0].rings, action.payload.latlng, store.applicationReducer.toolboxMailMergeState.selectionBuffer),
              new DelayedAction([new RefreshDisplayedGeoJson()])
            ];
          }),
          catchError((error: HttpErrorResponse) => {
            return of(
              new ToastUserNotification({
                type: 'fail',
                title: '',
                message: '',
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            );
          })
        );
    })
  ));


  //ToolboxMailMergeBuffer
  toolboxMailMergeBuffer$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.ToolboxMailMergeBuffer),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [ToolboxMailMergeBuffer, State]) => {
      const rings = { rings: store.applicationReducer.toolboxMailMergeState.bufferedArea.json.features[0].geometry.coordinates };
      return this.propertiesService.getPropsByGeometry(rings)
        .pipe(
          mergeMap((result: any) => {
            console.log(result);
            const actions = [];
            const latlng = action.payload.latlng;
            if (result.features?.length > 0) {
              actions.push(
                new ToolboxMailMergeSelectedParcels(result.features.map((f: any) => {
                  return {
                    url: f.attributes.DBLink,
                    json: {
                      features: [{
                        geometry: {
                          coordinates: f.geometry.rings,
                          type: 'Polygon' // Could be MultiPolygon if f.geometry.rings has more than one ring?
                        },
                        type: 'Feature'
                      }]
                    }
                  };
                })
                )
              );
            } else if (result.features?.length === 0) {
              // lat = 49.xxxx
              actions.push(
                new ToolboxMailMergeToggleParcelAtCoordinate({ latlng: latlng })
              )
            } else if (result.error) {
              // multipolygon
              actions.push(
                new ToolboxMailMergeToggleParcelAtCoordinate({ latlng: latlng })
              )
            }
            actions.push(
              new DelayedAction([new RefreshDisplayedGeoJson()])
            );

            return actions;
          })
        )

    })
  ));


  // ToolboxMailMergeToggleParcel
  toolboxMailMergeToggleParcelAtCoordinate$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.ToolboxMailMergeToggleParcelAtCoordinate),
    switchMap((action: any) => this.propertiesService.getPropertyByXY(action.payload.latlng)
      .pipe(
        switchMap((data: any) => {
          if (data.features && data.features.length > 0) {
            const dbLink = data.features[0].attributes.DBLink;
            return this.searchService.getShape(dbLink)
              .pipe(
                switchMap((data: any) => {
                  return [new ToolboxMailMergeToggleParcel(
                    {
                      url: dbLink,
                      json: data
                    }
                  ),
                  new DelayedAction([new RefreshDisplayedGeoJson()])

                  ];

                })
              )
          }
          else {
            return [
              new ToastUserNotification({
                type: 'fail',
                title: 'Parcel not located',
                message: 'Your map click did not locate a parcel. Please try again.',
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            ];
          }
        }
        )
      )
    )
  ));


  toolboxMailMergeUpdateRowcount$ = createEffect((): any => this.actions$.pipe(
    ofType(
      ApplicationActionType.ToolboxMailMergeSelectedParcels,
      ApplicationActionType.ToolboxMailMergeToggleParcel),
    throttleTime(1000),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [Action, State]) => {

      const mmstate = store.applicationReducer.toolboxMailMergeState;

      if (store.applicationReducer.toolboxStatus === ToolboxStatus.MailMerge) {
        if (mmstate.selectedParcels.length === 0 || !(mmstate.isOwners || mmstate.isOccupants)) {
          return [new ToolboxMailMergeUpdateResultCountSuccess(0)];
        }

        return this.searchService.getMailLabelsCount(mmstate)
          .pipe(
            switchMap((data: any) => {
              if (store.applicationReducer.toolboxMailMergeState.resultCount !== data) {
                return [new ToolboxMailMergeUpdateResultCountSuccess(data)];
              }
              return [];
            }
            )
          )
      }

    })
  ));

  // separated out from toolboxMailMergeUpdateRowcount effect and removed throttleTime 
  // because count doesn't update if user clicks too fast after selecting parcel
  toolboxMailMergeUpdateOptions$ = createEffect((): any => this.actions$.pipe(
    ofType(
      ApplicationActionType.ToolboxMailMergeUpdateOptions),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [Action, State]) => {

      const mmstate = store.applicationReducer.toolboxMailMergeState;

      if (mmstate.selectedParcels.length === 0 || !(mmstate.isOwners || mmstate.isOccupants)) {
        return [new ToolboxMailMergeUpdateResultCountSuccess(0)];
      }

      return this.searchService.getMailLabelsCount(mmstate)
        .pipe(
          switchMap((data: any) => {
            if (store.applicationReducer.toolboxMailMergeState.resultCount !== data) {
              return [new ToolboxMailMergeUpdateResultCountSuccess(data)];
            }
            return [];
          }
          )
        )

    })
  ));


  getMailMergeList$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetMailMergeList),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [Action, State]) => this.searchService.getMailLabels(store.applicationReducer.toolboxMailMergeState)
      .pipe(
        mergeMap((data: any): any => {
          // console.log(data);


          if (data.length > 0) {

            const labelsList = data;
            const headerKey = ['name', 'address', 'underConstruction'];
            const header = ['Name', 'Address', 'Under Construction'];
            const getValue = (key: string, obj: any): string => { return obj[key]; }
            const quote = '"';
            const csvString = (value: string) => (value === null ? '' : quote + value.toString().replace('\n', '\r') + quote);
            const csv = labelsList.map((row: any) =>
              headerKey
                .map((fieldName: string) => csvString(getValue(fieldName, row)))
                .join(',')
            );

            csv.unshift(header.join(','));
            const labelListArray = csv.join('\r\n');
            const blob = new Blob([labelListArray], { type: 'text/csv' });

            saveAs(blob, 'address-labels.csv');
          }

          return [];
        }
        )
      )
    )
  ));

  ExportInspections$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.ExportInspections),
    withLatestFrom(this.store$),
    mergeMap(([action, store]: [any, State]): any => {
      const feature = store.applicationReducer.kvSections;
      const featureHeader = [];
      const featureInfo = [];
      const exportData = [];
      for (let section of feature) {
        for (let pair of section.kvPair) {
          featureHeader.push(pair[0]);
          let val = pair[1];
          featureInfo.push('"' + val + '"');
        }
      }

      exportData.push(featureHeader.join(','));
      exportData.push(featureInfo.join(',') + '\r\n');
      const records = action.payload.records;
      let header = [];
      let lines = [];
      let assetId = '';
      if (records.length > 0) {
        for (let i = 0; i < records.length; i++) {
          const line = [];
          for (let x = 0; x < records[i].attrs.length; x++) {
            const pair = records[i].attrs[x];

            if (i === 0) {
              header.push(pair[0]);
              if (pair[0].toLowerCase().indexOf('asset') > -1 && pair[0].toLowerCase().indexOf('id') > -1) {
                assetId = pair[1];
              }
            }
            if (pair) {
              line.push(pair[1]);
            }

          }
          lines.push(line.join(','));
        }

        //  console.log(header);
        exportData.push(header.join(','));
        exportData.push(lines.join('\r\n'));
        const csv = exportData.join('\r\n');
        // console.log(csv);

        const blob = new Blob([csv], { type: 'text/csv' });
        let fileName = action.payload.tblName.replaceAll(' ', '-') + '.csv';
        if (assetId !== '') {
          fileName = action.payload.tblName.replaceAll(' ', '-') + '_' + assetId + '.csv';
        }

        saveAs(blob, fileName);
      }
      return [];
    }
    )
  ));

  // RefreshDisplayedGeoJson
  refreshDisplayedGeoJson$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.RefreshDisplayedGeoJson),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [RefreshDisplayedGeoJson, State]) => {

      const geoJsonToDisplay: any[] = [];

      // Search highlight
      if (store.applicationReducer.search && store.applicationReducer.search.success) {
        geoJsonToDisplay.push(store.applicationReducer.search.success);
      }

      // Property information
      if (store.propertiesState.geoJson.url) {
        geoJsonToDisplay.push(store.propertiesState.geoJson);
      }

      // Mail Merge related
      if (store.applicationReducer.toolboxMailMergeState.area.url) {
        geoJsonToDisplay.push(store.applicationReducer.toolboxMailMergeState.area);
      }

      if (store.applicationReducer.toolboxMailMergeState.bufferedArea.url) {
        geoJsonToDisplay.push(store.applicationReducer.toolboxMailMergeState.bufferedArea);
      }

      if (store.applicationReducer.toolboxMailMergeState.selectedParcels) {
        geoJsonToDisplay.push(...store.applicationReducer.toolboxMailMergeState.selectedParcels);
      }

      // Raster highlight
      if (store.applicationReducer.gridRasterHighlight.url) {
        geoJsonToDisplay.push(store.applicationReducer.gridRasterHighlight);
      }

      // features raster highlight
      if (store.applicationReducer.featureRasterHighlight.url) {
        geoJsonToDisplay.push(store.applicationReducer.featureRasterHighlight);
      }

      // population calculator - draw polygon
      if (store.applicationReducer.populationState.selectedArea?.url) {
        geoJsonToDisplay.push(store.applicationReducer.populationState.selectedArea);
      }

      return [
        new DelayedAction([
          new SetMapGeoJsonLayers(geoJsonToDisplay)
        ])
      ];

    })
  ));

  getEditPermission$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetEditPermission),
    switchMap((action: any) => {
      return this.editFeatureService.getEditPermission();
    }),
    mergeMap((data: any) => {
      // console.log(data);
      return [
        new SetEditPermission(data)
      ];
    })
  ));

  saveEditFeature$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.SaveEditFeature),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [SaveEditFeature, State]) => {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });
      const body = this.createJson(action.payload.formValues, action.payload.latlng, action.payload.shape, store.applicationReducer.userProfile.userPrincipalName);

      return this.httpClient.post(action.payload.writeUrl + '/addFeatures', body, { headers: headers })
        .pipe(
          catchError((): any => ([])),
          map(data => data),
          mergeMap((response: any) => {
            if (response && response.error) {
              return [
                new ToastUserNotification({
                  type: 'error',
                  title: 'Cannot add',
                  message: 'There was a problem adding the feature. Error: ' + JSON.stringify(response.error),
                  options: {
                    disableTimeOut: true,
                    closeButton: true
                  }
                }),
                new SetShowSpinner(false)
              ];
            } else {
              return [
                new DelayedAction([
                  new SetEditFeaturesPermission(null),
                  new CheckLayerDisplay(),
                  new ToastUserNotification({
                    type: 'success',
                    title: 'Feature added',
                    message: 'Feature was successfully added',
                    options: {
                      disableTimeOut: false,
                      closeButton: true
                    }
                  }),
                  new DelayedActionBy1([
                    new GetMaxAssetId({ url: action.payload.writeUrl, name: store.mapState.editFeaturesPermission.autoIncrementField }),
                    new SetEditFeaturesPermission(store.mapState.editFeaturesPermission),
                    new CheckLayerDisplay(),
                    new RefreshDisplayedGeoJson(),
                    new SetShowSpinner(false),
                  ])
                ])
              ];
            }

          })
        )
    })
  ));

  updateEditFeature$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.UpdateEditFeature),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [UpdateEditFeature, State]) => {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });
      const body = this.createJson(action.payload.formValues, null, action.payload.shape, store.applicationReducer.userProfile.userPrincipalName);

      return this.httpClient.post(action.payload.writeUrl + '/updateFeatures', body, { headers: headers })
        .pipe(
          catchError((): any => ([])),
          map(data => data),
          mergeMap((response: any) => {
            if (response && response.error) {
              return [
                new ToastUserNotification({
                  type: 'error',
                  title: 'Cannot update',
                  message: 'There was a problem updating the feature. Error: ' + JSON.stringify(response.error),
                  options: {
                    disableTimeOut: true,
                    closeButton: true
                  }
                }),
                new SetShowSpinner(false)
              ];
            } else {
              return [
                new SetShowSpinner(false),
                new DelayedAction([
                  new SetEditFeaturesPermission(null),
                  new CheckLayerDisplay(),
                  new ToastUserNotification({
                    type: 'success',
                    title: 'Feature updated',
                    message: 'Feature was successfully updated',
                    options: {
                      disableTimeOut: false,
                      closeButton: true
                    }
                  }),
                  new SelectFeature(null),
                  new SetSurroundingFeatureList(null),
                  new SetFeatureRasterHighlight({}),
                  new ToggleFeaturePanel(null),
                  new DelayedAction([
                    new DelayedActionBy1([
                      new DelayedAction([
                        new SetEditFeaturesPermission(store.mapState.editFeaturesPermission),
                        new CheckLayerDisplay(),
                        new RefreshDisplayedGeoJson(),
                      ])
                    ])
                  ])
                ])
              ];
            }

          })
        )
    })
  ));

  // update geometry only
  updateEditFeatureGeo$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.UpdateEditFeatureGeometry),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [UpdateEditFeatureGeometry, State]) => {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });
      const body = this.createJsonGeometry(action.payload.objId, action.payload.latlng, action.payload.shape, store.applicationReducer.userProfile.userPrincipalName);

      return this.httpClient.post(action.payload.writeUrl + '/updateFeatures', body, { headers: headers })
        .pipe(
          catchError((): any => ([])),
          map(data => data),
          mergeMap((response: any) => {
            if (response && response.error) {
              return [
                new ToastUserNotification({
                  type: 'error',
                  title: 'Cannot update geometry',
                  message: 'There was a problem updating the feature geometry. Error: ' + JSON.stringify(response.error),
                  options: {
                    disableTimeOut: true,
                    closeButton: true
                  }
                }),
                new SetShowSpinner(false)
              ];
            } else {
              return [
                new SetShowSpinner(false),
                new DelayedAction([
                  new SetEditFeaturesPermission(null),
                  new CheckLayerDisplay(),
                  new ToastUserNotification({
                    type: 'success',
                    title: 'Feature geometry updated',
                    message: 'Feature geometry was successfully updated',
                    options: {
                      disableTimeOut: false,
                      closeButton: true
                    }
                  }),
                  new SelectFeature(null),
                  new SetSurroundingFeatureList(null),
                  new SetFeatureRasterHighlight({}),
                  new ToggleFeaturePanel(null),
                  new DelayedAction([
                    new DelayedActionBy1([
                      new DelayedAction([
                        new SetEditFeaturesPermission(store.mapState.editFeaturesPermission),
                        new CheckLayerDisplay(),
                        new RefreshDisplayedGeoJson(),
                      ])
                    ])
                  ]),
                ])
              ];
            }

          })
        )
    })
  ));

  deleteEditFeature$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.DeleteEditFeature),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [DeleteEditFeature, State]) => {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });

      const query = 'f=pjson&rollbackOnFailure=true&objectIds=' + action.payload.objId;

      return this.httpClient.post(action.payload.writeUrl + '/deleteFeatures', query, { headers: headers })
        .pipe(
          catchError((): any => ([])),
          map(data => data),
          mergeMap((response: any) => {
            if (response && response.deleteResults[0]) {
              if (response.deleteResults[0].error) {
                return [
                  new ToastUserNotification({
                    type: 'error',
                    title: 'Cannot delete',
                    message: 'There was a problem deleting the feature with objectId ' + action.payload.objId + '. Error: ' + JSON.stringify(response.error),
                    options: {
                      disableTimeOut: true,
                      closeButton: true
                    }
                  }),
                  new SetShowSpinner(false)
                ];
              } else {
                return [
                  new DelayedAction([
                    new SetEditFeaturesPermission(null),
                    new CheckLayerDisplay(),
                    new ToastUserNotification({
                      type: 'success',
                      title: 'Feature deleted',
                      message: 'Feature was successfully deleted',
                      options: {
                        disableTimeOut: true,
                        closeButton: true
                      }
                    }),
                    new SelectFeature(null),
                    new SetSurroundingFeatureList(null),
                    new SetFeatureRasterHighlight({}),
                    new ToggleFeaturePanel(null),
                    new DelayedActionBy1([
                      new SetEditFeaturesPermission(store.mapState.editFeaturesPermission),
                      new CheckLayerDisplay(),
                      new RefreshDisplayedGeoJson(),
                      new SetShowSpinner(false)
                    ])
                  ])
                ];
              }
            }
          })
        )
    })
  ));

  GetMaxAssetId$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetMaxAssetId),
    switchMap((action: any) => this.editFeatureService.getMaxAssetId(action.payload.url, action.payload.name)
      .pipe(
        switchMap((data: any) => {
          return [
            new SetMaxAssetId({ assetId: data.features[0].attributes[action.payload.name], name: action.payload.name })
          ];
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new GetMaxAssetIdError(error.message));
        })
      )
    )
  ));


  GetEditFeatureFields$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetEditFeatureFields),
    switchMap((action: any) => this.editFeatureService.getEditFeatureFields(action.payload)
      .pipe(
        switchMap((data: any) => {
          // console.log(data);
          return [
            new SetEditFeatureFields(data.fields)
          ];
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new GetEditFeatureFieldsError(error.message));
        })
      )
    )
  ));

  GetEditRequiredFields$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetEditRequiredFields),
    switchMap((action: any) => this.editFeatureService.getEditRequiredFields()
      .pipe(
        switchMap((data: any) => {
          return [
            new SetEditRequiredFields(data)
          ];
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new GetEditRequiredFieldsError(error.message));
        })
      )
    )
  ));

  GetEditReadOnlyFields$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetEditReadOnlyFields),
    switchMap((action: any) => this.editFeatureService.getEditReadOnlyFields()
      .pipe(
        switchMap((data: any) => {
          return [
            new SetEditReadOnlyFields(data)
          ];
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new GetEditReadOnlyFieldsError(error.message));
        })
      )
    )
  ));

  GetAppSettings$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetAppSettings),
    switchMap((action: any) => this.appSettingService.getAppSettings()
      .pipe(
        switchMap((data: any) => {
          // console.log(data);
          return [
            new SetAppSettings(data)
          ];
        }
        ),
        catchError((error: HttpErrorResponse) => {
          return of(new GetAppSettingsError(error.message));
        })
      )
    )
  ));

  RefreshActiveLegends$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.RefreshActiveLegends),
    throttleTime(1000),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [Action, State]) => {

      let featureLayers: DnvFeatureLayer[];

      if (store.mapState.featureLayers) {
        featureLayers = store.mapState.featureLayers.filter(fl => fl.isVisible);
      }

      const activeLegends: LayerInfo[] = [];

      const error: any[] = [];
      if (featureLayers) {
        for (const fl of featureLayers) {
          if (Number(fl.gisLayerNum)) {
            const legend = store.legendState.legendCache.find(
              (l: any) => Number(fl.gisLayerNum) === l.layerId && fl.name === l.layerName);
            if (legend) {
              activeLegends.push(legend);
            } else {
              error.push(fl.name);
            }
          } else {
            if (fl.uid.indexOf('WMRP_SCHEDULE') > -1) {
              let legend = store.legendState.legendCache.find((l: any) => 'WMRP Schedule' === l.layerName);

              // legend = Object.assign({}, legend, { layerName: fl.displayName });

              if (legend && !activeLegends.includes(legend)) {
                activeLegends.push(legend);
              }
            }
            else {
              // ie contours layers
              const legend = store.legendState.legendCache.find(
                (l: any) => fl.name === l.layerName);
              if (legend) {
                activeLegends.push(legend);
              } else {
                error.push(fl.name);

              }
            }
            // const legend = store.legendState.legendCache.find(
            //   (l: any) => fl.name === l.layerName);
            // if (legend) {
            //   activeLegends.push(legend);
            // } else {
            //   error.push(fl.name);
            // }
          }
        }
      }

      return [
        new SetActiveLegendLayers(activeLegends)
      ]

    })
  ));

  Featureclicked$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(DnvLayerActionType.FeatureClicked),
    withLatestFrom(this.store$),
    switchMap(
      ([action, store]: [any, any]): any => this.httpClient.get(
        action.payload.url + '?f=pjson'
      ).pipe(
        catchError(() => of([])),
        map(data => {
          return ({ json: data, oid: action.payload.objectId, url: action.payload.url, layerState: store.layerState });
        }),
      )
    ),
    mergeMap((res: any) => {
      const actionArr: Action[] = [];
      if (res && res.json && res.json.hasAttachments) {
        actionArr.push(
          new GetFeatureAttachments({ url: res.url, objectId: res.oid })
        )
      } else {
        actionArr.push(
          new SetFeatureAttachments(null)
        );
      }

      return actionArr;
    })

  ));

  // Check if there are inspections
  checkRelatedTables$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.CheckRelatedTables),
    switchMap(
      (action: CheckRelatedTables): any => this.httpClient.get(
        action.payload.url + '?f=pjson'
      ).pipe(
        catchError(() => of([])),
        map(data => {
          return ({ json: data, oid: action.payload.objectId, url: action.payload.url });
        }),
        // switchMap((data: any) => {
        //   if (data.json && (data.json.error || data.json.length === 0)) {
        //     return [data.json.error];
        //   }
        //   return this.getRelatedTables(data.json, data.oid, data.url);

        // })
      )
    ),
    mergeMap((data: any) => {
      // console.log('test: ', data);
      const actions: Action[] = [];
      const oid = data.oid;
      const url = data.url;
      const hasAttach = data.json.hasAttachments;
      for (let rel of data.json.relationships) {
        actions.push(
          new GetRelatedTables({ rel, hasAttach, oid, url })
        );
      }
      return actions;
    }),
    /*     mergeMap((res: any) => {
          const actionArr: Action[] = [];
          if (res && res.data && res.data.relatedRecordGroups) {
            actionArr.push(
              new SetRelatedRecords(res)
            );
            // if there is only one inspection, set lastSelectedInspection to object ID of inspection
            // if (res.data.relatedRecordGroups.length > 0) {
            //   if (res.data.relatedRecordGroups[0].relatedRecords.length === 1) {
            //     const inspObjId = res.data.relatedRecordGroups[0].relatedRecords[0].attributes.OBJECTID;
            //     actionArr.push(
            //       // new InspectionClicked(inspObjId)
            //     );
            //   }
            // }
    
            if (res.data.relatedRecordGroups.length > 0) {
              for (let i = 0; i < res.data.relatedRecordGroups[0].relatedRecords.length; i++) {
                const rec = res.data.relatedRecordGroups[0].relatedRecords[i];
                const getInspAttachmentPayload: InspAttachmentPayload = {
                  url: res.data.url,
                  objectId: rec.attributes.OBJECTID,
                  relatedTableId: res.data.relatedTableId
                };
                actionArr.push(
                  new GetInspAttachment(getInspAttachmentPayload)
                );
              }
            }
            // return actionArr;
          } else if (res && res.length === 0) {
            actionArr.push(
              new SetRelatedRecords([])
            );
    
          } else {
            const errorMsg = res.message ? res.message : res.data && res.data.message ? res.data.message : 'error';
            actionArr.push(
              new ToastUserNotification({
                type: 'error',
                title: 'Can\'t get related records',
                message: errorMsg,
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            );
    
          }
    
          return actionArr;
        }) */

  ));

  getAttachment$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetAttachment),
    withLatestFrom(this.store$),
    map(([action, store]) => {
      return { action, token: store.mapState.arcGisToken };
    }),
    mergeMap((data): any => {
      return this.extractInspAttachments((data.action as any).payload.url, (data.action as any).payload.objectId, (data.action as any).payload.relatedTableId, data.token)
        .pipe(
          // tslint:disable-next-line: deprecation
          catchError(() => of([])),
          mergeMap((data: any) => {
            if (!data.message) {
              return [
                new SetRelatedAttachments(data)
              ];

            } else {
              return [
                new ToastUserNotification({
                  type: 'error',
                  title: 'Inspection Attachment Errors',
                  message: data.message,
                  options: {
                    disableTimeOut: true,
                    closeButton: true
                  }
                })
              ];
            }

          })
        );
    })
  ));

  getAttachments$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetAttachments),
    withLatestFrom(this.store$),
    map(([action, store]) => {
      return { action, token: store.mapState.arcGisToken };
    }),
    mergeMap((data): any => {
      let action = data.action as any;
      return this.extractAllInspAttachments(action.payload.url, action.payload.objectIds, action.payload.relatedTableId, data.token)
        .pipe(
          // tslint:disable-next-line: deprecation
          catchError(() => of([])),
          mergeMap((data: any) => {
            if (!data.message) {
              return [
                new SetRelatedAttachments(data)
              ];
            } else {
              return [
                new ToastUserNotification({
                  type: 'error',
                  title: 'Inspection Attachment Errors',
                  message: data.message,
                  options: {
                    disableTimeOut: true,
                    closeButton: true
                  }
                })
              ];
            }
          })
        );
    })
  ));

  getFeatureAttachment$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetFeatureAttachments),
    mergeMap((action: GetFeatureAttachments): any => {
      return this.httpClient.get(
        action.payload.url + '/'
        + action.payload.objectId
        + `/attachments?f=pjson`)
        .pipe(
          // tslint:disable-next-line: deprecation
          catchError(() => of([])),
          // tslint:disable-next-line: no-shadowed-variable
          map(data => {
            return ({ url: action.payload.url, data: data, objId: action.payload.objectId });
          }),
          // tslint:disable-next-line: no-shadowed-variable
          withLatestFrom(this.store$),
          map(([data, store]) => this.extractAttachments(data.url, data.data, data.objId, store.mapState.arcGisToken)),
          mergeMap((urls: any) => {
            if (urls.images && urls.images.length > 0) {
              return [
                new SetFeatureAttachments(urls),
                new ShowThumbnails()
              ];
            } else if (urls.images && urls.images.length === 0) {
              return [
                new SetFeatureAttachments(null)
              ];
            } else {
              return [new ToastUserNotification({
                type: 'error',
                title: 'Can\'t get attachment',
                message: 'Can\'t get attachment',
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })];
            }
          })
        );
    })
  ));

  getRelatedTables$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetRelatedTables),

    concatMap((action: GetRelatedTables): any => {
      const queryUrl = action.payload.url + '/queryRelatedRecords?objectIds=' + action.payload.oid + '&relationshipid=' + action.payload.rel.id + '&outFields=*&f=pjson';
      return this.httpClient.get(queryUrl)
        .pipe(
          // tslint:disable-next-line: deprecation
          catchError(() => of([])),
          // tslint:disable-next-line: no-shadowed-variable
          map(data => {
            return ({ url: action.payload.url, data: data, objId: action.payload.oid, relatedTableId: action.payload.rel.relatedTableId, attach: action.payload.hasAttach });
          })

        );
    }),
    mergeMap((res: any) => {
      const meta = res.data.fields;
      if (res.error) {
        // return { data: res.error };
      }
      const actionArr: Action[] = [];
      if (res && res.data && res.data.relatedRecordGroups) {
        if (res.data.relatedRecordGroups.length > 0) {
          const relRecords = {
            data: {
              fields: res.data.fields,
              relatedRecordGroups: res.data.relatedRecordGroups,
              url: res.url,
              relatedTableId: res.relatedTableId
            },
            hasAttachments: res.attach,
            relTblName: res.relTblName,
            meta: res.data.fields,
            objId: res.objId
          }

          actionArr.push(
            new GetRelTblName(relRecords)
          );

          if (res.data.relatedRecordGroups && res.data.relatedRecordGroups.length > 0 && res.data.relatedRecordGroups[0].relatedRecords && res.data.relatedRecordGroups[0].relatedRecords.length > 0) {
            let relatedRecords: any[] = res.data.relatedRecordGroups[0].relatedRecords;
            let objectIds: number[] = relatedRecords.map(rec => rec.attributes.OBJECTID);
            if (res.attach) {
              actionArr.push(new GetAttachments({
                url: res.url,
                objectIds: objectIds,
                relatedTableId: res.relatedTableId
              }));
            }
          }
        }
      } else if (res && res.length === 0) {
        actionArr.push(
          new SetRelatedRecords([])
        );
      } else {
        const errorMsg = res.message ? res.message : res.data && res.data.message ? res.data.message : 'error';
        actionArr.push(
          new ToastUserNotification({
            type: 'error',
            title: 'Can\'t get reports',
            message: errorMsg,
            options: {
              disableTimeOut: true,
              closeButton: true
            }
          })
        );

      }
      return actionArr;
    })
  ));

  GetRelTblName$: Observable<any> = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetRelTblName),
    switchMap(
      (action: any): any => {
        const serverUrl: string = action.payload.data.url.substring(0, action.payload.data.url.lastIndexOf('/'));
        return this.httpClient.get(
          serverUrl + '/' + action.payload.data.relatedTableId + '?f=pjson'
        ).pipe(
          catchError(() => of([])),
          map((data: any) => {
            return ({ name: data.name, records: action.payload, subtypeField: data.subtypeField, subtypes: data.subtypes });
          }),
        )
      }),
    mergeMap((res: any) => {
      return [
        new ConcatRelatedRecords(res)
      ];
    })

  ));

  getFlowWorksData$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetFlowWorksData),
    switchMap((action: GetFlowWorksData) =>
      this.featureService.getFlowWorksData(action.payload).pipe(
        catchError(() => of([])),
        map((data) => ({ data: data, payload: action.payload }))
      )
    ),
    mergeMap((fw: any) => {
      if (fw.data && fw.data.length > 0) {
        return [
          new SetExternalFeature({ message: '', pending: false }),
          new ConcatSelectedFeatureSections({ title: 'FlowWorks Information', kvPair: fw.data }),
          new ToggleAlert(true)
        ]
      } else {
        return [
          new SetExternalFeature({ message: '', pending: false }),
          new ToggleAlert(false),
          //  new SetRetryContext(fw.payload)
        ]
      }

    })
  ));

  GetCAD$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetCAD),
    switchMap((action: any) => this.searchService.GetCAD()
      .pipe(
        mergeMap((data: any) => {
          return [
            new SetCAD(data),
          ];
        }
        )
      )
    )
  ));

  GetOutstandingED$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.GetOutstandingED),
    switchMap((action: any) => this.searchService.GetOutstandingED()
      .pipe(
        mergeMap((data: any) => {
          return [
            new SetOutstandingED(data),
          ];
        }
        )
      )
    )
  ));

  UpdateEngDraw$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.UpdateEngDraw),
    switchMap((action: any) => this.searchService.updateEngDraw(action.payload.data, action.payload.type)
      .pipe(
        catchError(() => of([])),
        mergeMap((data: any) => {
          // console.log(data);

          if (data && (data.id || data.adminDrawing)) {
            return [
              // new SetOutstandingED(data),
              new ToastUserNotification({
                type: 'success',
                title: 'Saved',
                message: 'Changes were saved successfully',
                options: {
                  closeButton: true,
                  enableHtml: true,
                  timeOut: 5000
                }
              }),
              new GetCAD(),
              new GetOutstandingED()
            ];
          } else {
            return [
              // new SetOutstandingED(data),
              new ToastUserNotification({
                type: 'fail',
                title: 'The operation failed',
                message: 'Changes were not saved',
                options: {
                  closeButton: true,
                  enableHtml: true,
                  timeOut: 5000
                }
              }),
              new GetCAD(),
              new GetOutstandingED()
            ];
          }

        }
        )
      )
    )
  ));

  PopulationSelectedArea$ = createEffect((): any => this.actions$.pipe(
    ofType(ApplicationActionType.PopulationSelectedArea),
    throttleTime(1000),
    withLatestFrom(this.store$),
    switchMap(([action, store]: [PopulationSelectedArea, State]) => {

      const rings = { rings: store.applicationReducer.populationState.selectedArea.json.features[0].geometry.coordinates };
      return this.propertiesService.getBldgAssetIdByGeometry(rings)
        .pipe(
          mergeMap((result: any) => {
            console.log(result);
            const actions = [];

            const assets = result.features.map((f: any) => { return { assetId: f.attributes.Asset_Id, population: f.attributes.Population } });
            return [
              new PopulationSetState(assets)
            ];

          })
        )
    }
    )
  ));


  // TODO not sure we need the dateCorrected?
  private createJson(values: any, latlng: any, shape: string, upn: string) {

    // const timestamp = (new Date()).getTime();
    // // Values set one time only
    // if (!values.hasOwnProperty('GT_created_user') || values['GT_created_user'].length === 0) {
    //   values['GT_created_user'] = upn;
    // }
    // if (!values.hasOwnProperty('GT_created_date') || Number(values['GT_created_date']) === 0) {
    //   values['GT_created_date'] = timestamp;
    // }

    // // Update these every time
    // values['GT_last_edited_user'] = upn;
    // values['GT_last_edited_date'] = timestamp;


    let dateCorrected = '';
    if (values.DateCorrected) {
      dateCorrected = values.DateCorrected.year + '-' + values.DateCorrected.month + '-' + values.DateCorrected.day;
      const today = new Date();
      const currentTime = today.getUTCHours() + ':' + today.getUTCMinutes() + ':' + today.getUTCSeconds();
      dateCorrected = dateCorrected + ' ' + currentTime;
    }
    let valueString = '';
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        const keyToLowerCase = key.toLowerCase();
        if (!['attachment', 'datecorrected', 'objectid'].includes(keyToLowerCase)) {
          if (values[key] !== null) {
            if (values[key].length === 0) {
              valueString = valueString + '"' + key + '": null,';
            } else {
              valueString = valueString + '"' + key + '":"' + values[key] + '",';
            }
          }
        } else if (keyToLowerCase === 'datecorrected') {
          if (dateCorrected.length > 0) {
            valueString = valueString + '"' + key + '":"' + dateCorrected + '",';
          }
        } else if (keyToLowerCase === 'objectid' && values[key] && values[key].length > 0) {
          valueString = valueString + '"' + key + '":' + values[key] + ',';  // no quotes around values[key]
        }
      }
    }

    if (latlng) {
      if (shape.toLowerCase().indexOf('line') > -1) {
        let geoStr = '';
        for (let i = 0; i < latlng.length; i++) {
          geoStr = geoStr + '[' + latlng[i].lng + ', ' + latlng[i].lat + '],';
        }
        valueString = '[{"attributes": {' + valueString + '}, "geometry":{"paths":[[' + geoStr + ']], "spatialReference" : {"wkid" : 4326}} }]';
      } else if (shape.toLowerCase().indexOf('point') > -1) {
        valueString = '[{"attributes": {' + valueString + '}, "geometry":{ "x":' + latlng.lng + ', "y": ' + latlng.lat + ', "spatialReference" : {"wkid" : 4326}} }]';
      } else if (shape.toLowerCase().indexOf('polygon') > -1) {
        let geoStr = '';
        const polygon = latlng[0];
        for (let i = 0; i < polygon.length; i++) {
          geoStr = geoStr + '[' + polygon[i].lng + ', ' + polygon[i].lat + '],';
        }
        valueString = '[{"attributes": {' + valueString + '}, "geometry":{"rings":[[' + geoStr + ']], "spatialReference" : {"wkid" : 4326}} }]';
      }
    } else {
      valueString = '[{"attributes": {' + valueString + '} }]';
    }


    const queryString = 'f=pjson&rollbackOnFailure=true&features=' + encodeURIComponent(valueString);
    return queryString;
  }

  createJsonGeometry(objId: number, latlng: any, shape: string, upn: string) {
    const timestamp = (new Date()).getTime();

    let geo = '';
    if (shape.toLowerCase().indexOf('line') > -1) {
      let geoStr = '';
      for (let i = 0; i < latlng.length; i++) {
        geoStr = geoStr + '[' + latlng[i].lng + ', ' + latlng[i].lat + '],';
      }
      geo = '{"paths":[[' + geoStr + ']], "spatialReference" : {"wkid" : 4326}}';
    } else if (shape.toLowerCase().indexOf('point') > -1) {
      geo = '{ "x":' + latlng.lng + ', "y": ' + latlng.lat + ', "spatialReference" : {"wkid" : 4326}}';
    } else if (shape.toLowerCase().indexOf('polygon') > -1) {
      let geoStr = '';

      for (let i = 0; i < latlng.length; i++) {
        geoStr = geoStr + '[' + latlng[i].lng + ', ' + latlng[i].lat + '],';
      }
      geo = '{"rings":[[' + geoStr + ']], "spatialReference" : {"wkid" : 4326}}';
    }
    return 'f=pjson&rollbackOnFailure=true&features=[{ "attributes": { "objectid":' + objId + ' }, "geometry":' + geo + '}]';
  }

  private createToolboxMailMergeBuffer(geometry: any, latlng: LatLng = null, selectionBuffer: number = 0) {

    return new ToolboxMailMergeBuffer(
      {
        url: 'MailMergeBufferGeometry' + new Date().toISOString(), // create a unique url
        json: {
          features: [{
            geometry: {
              coordinates: geometry,
              type: geometry.length === 1 || (geometry.length > 1 && selectionBuffer > 0) ? 'Polygon' : 'MultiPolygon' // Could be MultiPolygon if f.geometry.rings has more than one ring?
            },
            type: 'Feature'
          }]
        },
        style: {
          fillColor: '#222222',
          weight: 2,
          opacity: 1,
          color: 'red',
          fillOpacity: 0.4
        },
        latlng: latlng
      }
    );
  }

  /*   private getRelatedTables(data: any, objId: number, url: string): any {
      if (data.relationships && data.relationships.length > 0) {
        const relationId = data.relationships[0].id;
        const relTableId = data.relationships[0].relatedTableId;
        const hasAttachments = data.hasAttachments;
        const queryUrl = url + '/queryRelatedRecords?objectIds=' + objId + '&relationshipid=' + relationId + '&outFields=*&f=pjson';
        return this.httpClient.get(queryUrl)
          .pipe(
            // tslint:disable-next-line: deprecation
            catchError(() => of([])),
            // tslint:disable-next-line: no-shadowed-variable
            map((data: any) => {
              console.log(data);
              data.relatedTableId = relTableId;
              data.url = url;
              const meta = data.fields;
              if (data.error) {
                return { data: data.error };
              }
              return { data, meta, hasAttachments, objId };
            })
          );
      }
      return [];
    } */

  private extractInspAttachments(url: string, objectId: number, tblId: number, arcgisToken: ArcGisToken) {
    const serverUrl: string = url.substring(0, url.lastIndexOf('/'));
    const queryUrl = serverUrl + '/' + tblId + '/' + objectId + '/attachments?f=pjson';
    return this.httpClient.get(queryUrl).pipe(
      // tslint:disable-next-line: deprecation
      catchError(() => of([])),
      map((attachData: any) => {

        attachData.parentID = objectId;
        attachData.attachment = [];
        if (attachData.attachmentInfos) {
          for (let i = 0; i < attachData.attachmentInfos.length; i++) {
            const parentId = attachData.parentID;
            const attachmentId = attachData.attachmentInfos[i].id;
            const fileName = attachData.attachmentInfos[i].name;
            const encServiceUrl = encodeURIComponent(serverUrl + '/' + tblId);
            const imgUrl = `${this.configService.webApiEndpoint}layerattachment/${parentId}/${attachmentId}/${fileName}?token=${arcgisToken.token}&serviceUrl=${encServiceUrl}`
            const fileType = this.getFileType(imgUrl);
            attachData.attachment.push({ small: imgUrl, medium: imgUrl, big: imgUrl, type: fileType });
          }
          return { attachData };
        } else {
          return { message: 'Can\'t get inspection attachments' };
        }
      })
    );
  }

  private extractAllInspAttachments(url: string, objectIds: number[], tblId: number, arcgisToken: ArcGisToken) {
    const serverUrl: string = url.substring(0, url.lastIndexOf('/'));
    const queryUrl = serverUrl + '/' + tblId + '/queryAttachments?objectIds=' + objectIds.join(',') + '&f=json';
    return this.httpClient.get(queryUrl).pipe(
      // tslint:disable-next-line: deprecation
      catchError(() => of([])),
      map((allAttachData: any) => {
        if (allAttachData.attachmentGroups) {
          let attachments: any[] = allAttachData.attachmentGroups;
          for (let i = 0; i < attachments.length; i++) {
            let attachData = attachments[i];
            attachData.parentID = attachData.parentObjectId;
            attachData.attachment = [];
            if (attachData.attachmentInfos) {
              for (let i = 0; i < attachData.attachmentInfos.length; i++) {
                const parentId = attachData.parentID;
                const attachmentId = attachData.attachmentInfos[i].id;
                const fileName = attachData.attachmentInfos[i].name;
                const encServiceUrl = encodeURIComponent(serverUrl + '/' + tblId);
                const imgUrl = `${this.configService.webApiEndpoint}layerattachment/${parentId}/${attachmentId}/${fileName}?token=${arcgisToken.token}&serviceUrl=${encServiceUrl}`
                const fileType = this.getFileType(imgUrl);
                attachData.attachment.push({ small: imgUrl, medium: imgUrl, big: imgUrl, type: fileType });
              }
            }
          }
          return attachments;
        }
        else {
          return { message: 'Can\'t get inspection attachments' };
        }
      })
    );
  }

  private getTableMeta(url: string, state: LayerState) {
    let tblMeta: any = [];
    state.layers.forEach(layer => {
      layer.featureLayers.forEach(fl => {
        if (fl.url === url) {
          tblMeta = layer.tableLayers[0].TableMeta;
        }
      });
    });

    return tblMeta;
  }

  private getKeyValue(arr: any, arrKey: string, arrKey2: string = ''): any {
    let objId = 0;
    for (let key of arr) {
      if (key[0].toLowerCase().indexOf(arrKey.toLowerCase()) > -1) {
        objId = key[1];
        break;
      }
    }
    // try with second key if there is one
    if(objId.toString().length=== 0 && arrKey2.length > 0){
    for (let key of arr) {
      if (key[0].toLowerCase().indexOf(arrKey2.toLowerCase()) > -1) {
        objId = key[1];
        break;
      }
    }
    }
    return objId;
  }

  private extractAttachments(url: any, attachments: any, objectId: any, arcgisToken: ArcGisToken) {
    const urls: any = { images: [], others: [] };
    if (attachments && attachments.attachmentInfos) {
      attachments.attachmentInfos.forEach((item: { id: string; contentType: string | string[]; size: any; name: any; }) => {
        const parentId = objectId;
        const attachmentId = item.id;
        const fileName = item.name;
        const encServiceUrl = encodeURIComponent(url);
        const fileUrl = `${this.configService.webApiEndpoint}layerattachment/${parentId}/${attachmentId}/${fileName}?token=${arcgisToken.token}&serviceUrl=${encServiceUrl}`;
        const fileType = this.getFileType(fileUrl);
        urls.images.push({ small: fileUrl, medium: fileUrl, big: fileUrl, type: fileType });
        // if (item.contentType.indexOf('image') > -1) {
        //   urls.images.push({ small: fileUrl, medium: fileUrl, big: fileUrl });
        // } else {
        //   urls.others.push({ url: fileUrl, size: item.size, id: item.id, name: item.name });
        // }
      });

      return urls;
    }
    return [];

  }

  private getFileType(fileSource: string): string {
    const fileExtension = fileSource.split('.').pop().toLowerCase();
    if (fileExtension === 'avi' || fileExtension === 'flv'
      || fileExtension === 'wmv' || fileExtension === 'mov'
      || fileExtension === 'mp4' || fileExtension === 'm4v') {
      return 'video';
    }
    return 'image';
  }


  // private wmrpSymbolTemplate(value: number = 1, color: number[] = [255, 0, 0, 255]) {
  //   return {
  //     symbol: {
  //       style: 'esriSLSSolid',
  //       color,
  //       width: 3.5,
  //       type: 'esriSLS'
  //     },
  //     value,
  //   };
  // }

  // private wmrpSymbologyTemplate(layerId: number, assetIds: string[], color: number[] = [255, 0, 0, 255]) {


  //   const mapLayerId: number = layerId;
  //   const formattedAssetIds = assetIds.map(e => `'${e}'`).join(',');
  //   const definitionExpression = `Asset_Id IN (${formattedAssetIds})`;
  //   const uniqueValueInfos = [1, 2].map(v => this.wmrpSymbolTemplate(v, color));

  //   return {
  //     source: {
  //       type: 'mapLayer',
  //       mapLayerId
  //     },
  //     definitionExpression, //: Asset_Id IN ('WTRMN04838','WT10970','WTRMN09965'),
  //     drawingInfo: {
  //       renderer: {
  //         type: 'uniqueValue',
  //         field1: 'AM_Type',
  //         uniqueValueInfos,
  //       },
  //     }
  //   };
  // }
  private classBreakRenderer(mapLayerId: number, field: string, defaultSymbol: Symbol, classBreakInfos: { symbol: Symbol, classMaxValue: number }[], definitionExpression: string = null) {
    let renderer = [
      {
        source: {
          type: 'mapLayer',
          mapLayerId
        },
        drawingInfo: {
          renderer: {
            type: 'classBreaks',
            field,
            defaultSymbol,
            minValue: 0,
            classBreakInfos
          }
        },
        minScale: 0,
        maxScale: 0
      }
    ];

    if (definitionExpression) {
      renderer = renderer.map(r => Object.assign({}, r, { definitionExpression }));
    }

    return renderer;
  }



  constructor(
    private actions$: Actions,
    // tslint:disable-next-line: ngrx-no-typed-store
    private store$: Store<State>,
    private searchService: SearchService,
    private propertiesService: PropertiesService,
    private toastr: ToastrService,
    private router: Router,
    private layersService: LayersService,
    private arcGisService: ArcGisService,
    private basemapsService: BasemapsService,
    private metadataService: MetadataService,
    private featureService: FeaturesService,
    private configService: ConfigService,
    private editFeatureService: EditFeatureService,
    private appSettingService: AppSettingsService,
    private httpClient: HttpClient
  ) {
    this.store$.select(getApplicationState).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((state: any) => {
      this.appSettings = state.appSettings;
    });

  }

}
